var map = {
	"./Autodesk-Logo.jpg": 1114,
	"./Autodesk-logos.webp": 483,
	"./GoDaddy-Logo.wine.png": 1581,
	"./GoDaddy_logo.svg": 3918,
	"./address_image.svg": 3906,
	"./animated_logo.svg": 9083,
	"./apurva_logo.jpeg": 4862,
	"./blogs_image.svg": 7245,
	"./cloud_infrastructure.svg": 883,
	"./codeInLogo.png": 7873,
	"./cognizant_logo.jpeg": 7762,
	"./contactMail.png": 3189,
	"./coursera_logo.png": 1170,
	"./cyber_security_logo.png": 9350,
	"./data_science.svg": 8699,
	"./deeplearning_ai_logo.png": 9575,
	"./delhivery_logo.png": 2582,
	"./developerActivity.svg": 9257,
	"./dsc_logo.png": 8750,
	"./education.svg": 1118,
	"./esyasoft_logo.png": 7188,
	"./experience.svg": 7480,
	"./feelingProud.svg": 8294,
	"./freecopy_logo.png": 4633,
	"./fukoku_logo.jpg": 3093,
	"./fukoku_logo.png": 8629,
	"./fullstack.svg": 5137,
	"./gcp_logo.png": 1525,
	"./github_logo.png": 8017,
	"./googleAssistant.jpg": 1659,
	"./googleAssistant.svg": 7291,
	"./google_logo.png": 9389,
	"./growthpal_logo.jpeg": 9285,
	"./hackerrank_logo.png": 6166,
	"./home_animate.gif": 1588,
	"./ibm_logo.png": 262,
	"./ijesmr_logo.png": 4850,
	"./ijsem.png": 7202,
	"./ijsrem.png": 5234,
	"./ijsremlogo.webp": 3579,
	"./intel_logo.jpg": 8504,
	"./jsFramework.svg": 9655,
	"./kerv_logo.png": 166,
	"./legato_logo.png": 1236,
	"./manOnTable.svg": 7473,
	"./masai_logo.png": 189,
	"./microsoft_logo.png": 752,
	"./mozilla_logo.png": 6816,
	"./msbte.png": 4471,
	"./nextuLogo.jpg": 8497,
	"./nptel_logo.png": 7439,
	"./portfolio.gif": 8467,
	"./programmer.svg": 4700,
	"./projects_image.svg": 1240,
	"./pwa.png": 9180,
	"./ratatype-cloud.webp": 6846,
	"./ratatype.png": 6360,
	"./ratatype_logo.png": 3860,
	"./rt_logo.png": 5164,
	"./saayaHealthLogo.png": 4176,
	"./scalar_logo.jpg": 9502,
	"./sppu_img.png": 9186,
	"./stanford_logo.png": 6691,
	"./talksCardBack.svg": 6654,
	"./talksCardBackAlt.svg": 3291,
	"./ui_ux_design.svg": 9163,
	"./vaibhavmore.png": 6116,
	"./vaibhavmore_hd.png": 8277,
	"./vidyarthi_logo.png": 4928,
	"./vm.png": 6605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;